// extracted by mini-css-extract-plugin
export var divider = "_pw-0";
export var systemMessage = "_pw-1";
export var systemMessageWrapper = "_pw-2";